module.exports = __webpack_public_path__ + "static/img/news_top_03_1.dacee03e.gif";